module.exports = __webpack_public_path__ + "img/info-users.ae96e902.svg";